import { useApolloClient } from '@apollo/client';
import { signOut } from '@aws-amplify/auth';
import { useState } from 'react';
import { DeleteUserMutation } from '../../graphql/mutation/deleteUser';
import { store } from '../../store';
import { revertAll } from '../../store/actions';
import { hideLoader, showLoader } from '../../store/reducers/appSlice';
import { openToast, resetToast } from '../../store/reducers/toastSlice';
import { NavigationConfig } from '../../utils/navigation-constants';

const useAccountDelete = () => {
    const [isShowAccountDeletePopup, setShowAccountDeletePopup] = useState(false);
    const client = useApolloClient();
    const forceSignOutUser = () => {
        try {
            store.dispatch(showLoader());

            signOut()
                .then(() => {
                    store.dispatch(resetToast({ show: false, message: null, isAlertOpen: false }));
                    store.dispatch(revertAll());
                    localStorage.removeItem('authToken');
                    sessionStorage.clear();
                    client.clearStore();
                    window.location.href = NavigationConfig.Login;
                })
                .catch(err => {
                    store.dispatch(hideLoader());
                    console.error('err SignOut: ', err);
                })
                .finally(() => {
                    store.dispatch(hideLoader());
                });
        } catch (err) {
            store.dispatch(hideLoader());
            console.error('err forceSignOutUser==>', err);
        }
    };
    const onDeleteAccountHandler = async () => {
        try {
            store.dispatch(showLoader());
            const { data } = await client.mutate({
                mutation: DeleteUserMutation,
            });
            if (data?.deleteUser?.success) {
                store.dispatch(
                    openToast({
                        show: true,
                        message: data?.deleteUser?.message,
                        severity: 'success',
                        isAlertOpen: true,
                    }),
                );
                forceSignOutUser();
            }
            store.dispatch(hideLoader());
        } catch (err) {
            store.dispatch(hideLoader());
        }
    };
    const onPopupCloseHandler = async () => {
        setShowAccountDeletePopup(false);
    };
    const onShowAccountDeleteAlertHandler = async () => {
        setShowAccountDeletePopup(true);
    };

    return {
        onDeleteAccountHandler,
        isShowAccountDeletePopup,
        onPopupCloseHandler,
        onShowAccountDeleteAlertHandler,
    };
};

export { useAccountDelete };
